var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("top"),_c('base-section',{attrs:{"large":_vm.isSectionLarge(),"small":_vm.isSectionSmall()}},[_vm._t("default")],2),_vm._t("bottom")],2)}
var staticRenderFns = []

export { render, staticRenderFns }